<div class="modal" *transloco="let t; read: 'personalNumber'">
    <h1 class="modal__heading">{{ t("heading") }}</h1>

    <div class="modal__content">
        <div class="modal__content__title">{{t("missingPersonalNumber")}}</div>
        <div class="modal__content__info-message">{{t("addressPersonalNumber")}}</div>
        <div class="modal__form__container">
            <ha-input class="modal__form__field" type="personalNumber" [(ngModel)]="personalNumber" [label]="t('personalNumber')" (input)="personalNumberOnChange()"></ha-input>
            <ha-checkbox #noPersonalNumberCheckBox class="modal__content--checkbox" [(ngModel)]="hasForeignPersonalNumber" [label]="t('noSwedishPnr')" (click)="hasForeginPersonalNumberClick()"></ha-checkbox>
            <div *ngIf="(!isPersonalNumberValid)" class="modal__content__error-message">{{ t("invalidPnr") }}</div>
        </div>
    </div>

    <div class="modal__actions">
        <button class="modal__actions__cancel" type="button" (click)="cancel()">{{ t("cancel") }}</button>
        <button class="modal__actions__ok" type="button" [class.modal__actions__ok--disabled]="!isValid" (click)="accept()">{{t("accept") }}</button>
    </div>
</div>
